import { Pipe, PipeTransform } from '@angular/core';

import { CorrelationRate } from '../services/rate.service';

@Pipe({
  name: 'filterCorrelationRate',
  standalone: true
})
export class FilterCorrelationRatePipe implements PipeTransform {

  public transform(value: CorrelationRate[], searchValue: string): CorrelationRate[] {
    if (!searchValue || searchValue.length < 3) {
      return value;
    }
    const pattern = new RegExp('\\b' + searchValue.toLocaleLowerCase());
    return value.filter(rate => pattern.test(rate.rateName.toLocaleLowerCase()));
  }
}
